import { TrendingUp, Laptop, Handshake } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { JOIN } from "@/constants/testIds";

const CARDS = [
  {
    slug: "residual",
    Icon: TrendingUp,
    title: "Monthly Residual Income",
    body: "Earn ongoing monthly income on every client you secure. The more clients, the more residual revenue.",
    image: "/images/join-residual.png",
  },
  {
    slug: "flexibility",
    Icon: Laptop,
    title: "Work on Your Terms",
    body: "Set your own hours, work remotely, and build your business around your lifestyle.",
    image: "/images/join-flex.png",
  },
  {
    slug: "winwin",
    Icon: Handshake,
    title: "Non-Disruptive Value",
    body: "You're selling programs that save money, improve employee benefits, and cost nothing if savings aren't found. Everyone wins.",
    image: "/images/join-winwin.png",
  },
];

export default function OpportunitySection() {
  return (
    <section
      id="opportunity"
      data-testid={JOIN.opportunity}
      className="section-pad"
      style={{ background: "var(--color-bg-soft)", textAlign: "center" }}
    >
      <div className="container-wide">
        <Reveal>
          <div className="eyebrow mb-5" style={{ justifyContent: "center" }}>
            The opportunity
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="type-section-heading mb-5">
            Get paid every month. Forever.
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p
            className="type-body-large"
            style={{ maxWidth: 720, margin: "0 auto 64px", lineHeight: 1.65 }}
          >
            Once you help a business implement a SmartEdge program, you&apos;re set
            up for continuous monthly residual income. This isn&apos;t a one-time
            commission — you earn every single month that client stays active.
            Build a portfolio of 10, 20, 50+ clients and create a revenue stream
            that compounds over time.
          </p>
        </Reveal>

        <div
          data-testid={JOIN.benefits}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8"
          style={{ textAlign: "left" }}
        >
          {CARDS.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.15}>
              <article
                data-testid={JOIN.benefitCard(c.slug)}
                className="se-card h-full"
              >
                <div className="se-card__media">
                  <img src={c.image} alt={c.title} loading="lazy" />
                </div>
                <div className="se-card__body">
                  <span
                    className="flex items-center justify-center mb-4"
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 8,
                      background: "rgba(108,92,231,0.1)",
                      color: "var(--color-purple)",
                    }}
                  >
                    <c.Icon size={20} strokeWidth={1.5} />
                  </span>
                  <h3 className="type-subheading mb-3" style={{ fontSize: 22 }}>
                    {c.title}
                  </h3>
                  <p className="type-body">{c.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
